module.exports = __webpack_public_path__ + "static/media/car3.b684c685.png";